import React from "react";
import { FormattedMessage } from "react-intl";
import { Badge } from "reactstrap";
import styled from "styled-components";
import type { Chat } from "src/chats/objects/Chat";
import RaangeLabel, {
  type IRaangeLabelProps,
} from "src/shared/components/RaangeLabel";
import { FormattedInstantString } from "src/shared/formatters/FormattedInstant";

export interface IChatsLabelProps {
  count?: number;
}

export const ChatsLabel = ({ count }: IChatsLabelProps) => (
  <RaangeLabel fa="home">
    <FormattedMessage id="chats" />
    {Boolean(count && count > 0) && (
      <ChatLabelBadge color="danger" pill>
        {count}
      </ChatLabelBadge>
    )}
  </RaangeLabel>
);

const ChatLabelBadge = styled(Badge)`
  vertical-align: middle;
  margin-left: 0.5em;
`;

export interface IChatFormatterProps {
  chat: Chat;
}

export const ChatFirstCreated = ({
  chat: { firstCreated },
}: IChatFormatterProps) => {
  return <FormattedInstantString value={firstCreated} />;
};

export const ChatLanguage = ({
  chat: { languageCode },
}: IChatFormatterProps) => {
  return <Badge color="dark">{languageCode}</Badge>;
};

export const ChatCreate = (props: Omit<IRaangeLabelProps, "fa">) => {
  return (
    <RaangeLabel fa="plus" {...props}>
      <FormattedMessage id="chats.create" />
    </RaangeLabel>
  );
};
